import React from "react"
import { useStore } from "../../teafuljs/store"
import { getTranslation } from "../../scripts/getTranslation"
import { recordEvent } from "../../apis/googleAnalytics"

import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
  dialogTitle: {
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "space-between",
  },
  title: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  SVicons: {
    height: "50px",
    width: "50px",
    marginRight: "5px",
    marginBottom: "5px",
  },
  sourceName: {
    color: "rgb(180, 180, 180)",
    marginTop: "10px",
    marginBottom: "0px",
    fontSize: "80%",
    textTransform: "uppercase",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
  },
})

const SourceName = props => {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const classes = useStyles()
  const SVData = Object.assign(props.data, {
    words: props.words,
  })
  const hasInfo =
    SVData.sourceName &&
    SVData.unique_sources &&
    SVData.unique_recipients &&
    SVData.color
  if (
    props.sourceName === "The Narrator" ||
    props.sourceName === "The Compiler" ||
    props.sourceName === "The Preacher"
  ) {
    return null
  } else {
    return (
      <p
        className={classes.sourceName}
        id="source-name"
        onClick={
          hasInfo
            ? () => {
                recordEvent(
                  "Click Source Name",
                  `${language}-${version}`,
                  `${SVData.sourceName}`
                )
                props.newSourceViewDialog({ open: true, content: SVData })
              }
            : null
        }
      >
        {getTranslation(
          translations,
          language,
          "Sources",
          props.sourceName
        )}
      </p>
    )
  }
}

export default SourceName
